export const SIDE_DRAWER_WIDTH = 358;
export const TITLE_MAX_CHAR_LIMIT = 60;
export const QUERY_INPUT_MAX_CHAR_LIMIT = 300;
export const CHAT_REVIEW_MAX_CHAR_LIMIT = 500;
export const AXIOS_API_TIMEOUT = 120000;
export const DOWNLOAD_CITATION_API_TIMEOUT = 300000; // 5 Minutes
export const CHAT_FEEDBACK = {
  LIKED: 1,
  DISLIKED: 0,
  NO_FEEDBACK: -1,
};

export const CHAT_HISTORY_ACTIONS = {
  ACTIVE: 'Active-Chat',
  EDIT: 'Edit-Title',
  DELETE: 'Delete-Chat',
  PIN: 'Pin-Chat',
};

export const dateFormatOptions: Intl.DateTimeFormatOptions = {
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
};
